export default __webpack_public_path__ + "katar-tarihce.jpg";